export default {
  menuClose: "menu-close",
  setValue: "set-value"
};



// WEBPACK FOOTER //
// ./src/components/Common/Form/MultiSelect/reactSelectActions.js